<script>

export default {
    props: {
        'title': String,
        'value': Object,
        'success': Function,
    },
    data() {
        return {
            data: {},
            routeName: 'config-general',
        };
    },
    mounted() {
        var vm = this;

        vm.load();
    },
    methods: {
        load() {
            var vm = this;

            vm.newData();
            vm.create();
        },
        create() {
            var vm = this;

            vm.data = Object.assign({}, vm.value);
        },
        newData() {
            var vm = this;

            var data = {
                stuff_type_id: null,
                value: null
            };

            vm.data = Object.assign({}, data);
        },
        async submit() {
            var vm = this;
            vm.$loading.on('config_general_stuff_submit');

            try {
                var postData = vm._createPostData(vm.data);
                var resp = await this.$api.ConfigStuff.create(postData);

                var data = resp.data;

                vm.$flash.success(data.message);

                vm.success(vm.data);
                vm.$sidebar.hide();
            } catch (err) {
                vm.$flash.error(err.response.data.message);
            }
            vm.$loading.off('config_general_stuff_submit');
        },
        _createPostData: function (data) {
            return data;
        },
        fetchStuffType: async function (params) {
            var newParams = {
                ...params,
                page: 'all'
            }
            const resp = await this.$api.StuffType.all(newParams)

            const data = resp.data.data

            const list = data.map(row => ({
                id: row.id,
                text: row.text,
                model: row,
            }))

            const meta = resp.data.meta

            return {
                options: list,
                more: meta.current_page < meta.last_page
            }
        },
    }
}
</script>

<template>

    <b-form @submit="submit">
        <simplebar class="h-100 sidebar-simplebar">
            <div class="p-4">
                <BRow class="gy-3">
                    <BCol lg="12">
                        <label for="choices-publish-status-input" class="form-label">{{
                            $t('config_general.label.stuff_type') }}</label>
                        <dynamic-select v-model="data.stuff_type_id"
                            :placeholder="$t('config_general.placeholder.stuff_type')" :loadOptions="fetchStuffType" />
                    </BCol>
                    <BCol lg="12">
                        <label class="form-label" for="product-title-input">{{
                            $t('config_general.label.value')
                            }}</label>
                        <input type="text" class="form-control" v-model="data.value" id="product-title-input"
                            :placeholder="$t('config_general.placeholder.value')" />
                    </BCol>
                    <BCol lg="12" class="mt-5" v-if="$ac.hasAccess('config_general_create')">
                        <BRow>
                            <BCol cols="6">
                                <BButton type="button" variant="light" class="w-100" id="reset-layout"
                                    @click="$sidebar.hide()">
                                    <i class="mdi mdi-arrow-left align-bottom me-1"></i>
                                    {{ $t('basic.btn.cancel') }}
                                </BButton>
                            </BCol>
                            <BCol cols="6">
                                <BButton type="submit" variant="success" class="w-100" @click="submit"
                                    :disabled="$loading.get('config_general_stuff_submit')">
                                    <loading :loading="$loading.get('config_general_stuff_submit')" variant="light"
                                        type="button">
                                        <i class="mdi mdi-floppy me-1"></i>
                                        {{ $t('basic.btn.save') }}
                                    </loading>
                                </BButton>
                            </BCol>
                        </BRow>
                    </BCol>
                </BRow>
            </div>
        </simplebar>
    </b-form>
</template>